module.exports = __webpack_public_path__ + "assets/media/tongue_training.63d6bbd9.mp4";